import { Helmet } from 'react-helmet-async';
import env from '@/lib/env';

export function DefaultHelmet() {
  const noindex = env.get('VITE_ROBOTS_NOINDEX') === 'true';
  return (
    <Helmet>
      <meta name="robots" content={noindex ? 'noindex, nofollow' : 'index, follow'} />
      <meta property="og:site_name" content="BookMyCoaching" />
      <meta property="og:locale" content="en_IN" />
      <meta name="twitter:site" content="@bookmycoaching" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta property="og:type" content="website" />
    </Helmet>
  );
}
